import React from 'react'
import {
  Field,
  Input,
  IconSearch20,
} from '@lightspeed/unified-components-helios-theme/react'

import {
  useSearchableListModel,
  SearchableListProps,
} from './useSearchableListModel'

export const SearchableList = <T,>(props: SearchableListProps<T>) => {
  const model = useSearchableListModel(props)

  return (
    <>
      <div className="uc-base">
        <div className="p-6">
          <Field labelSlot={props.label}>
            <Input
              ref={model.inputRef}
              placeholder={props.searchPlaceholder}
              type="text"
              onChange={model.onSearch}
              prefixSlot={<IconSearch20 />}
            />
          </Field>
        </div>
      </div>

      <div className="uc-base" style={{ overflowY: 'auto' }}>
        <ol role="listbox" aria-label={props.label}>
          {model.filteredItems.map(item => {
            const key = props.getKey(item)
            const isActive = key === props.activeKey

            return (
              <li
                key={key}
                ref={isActive ? model.activeItemRef : undefined}
                role="option"
                aria-selected={isActive}
                onClick={() => props.onItemSelect(item)}
              >
                {props.renderItem(item, isActive, model.trimmedFilter)}
              </li>
            )
          })}
        </ol>
      </div>
    </>
  )
}
